import React from 'react'
import { Box, Typography } from '@mui/material'

// Red de seguridad alrededor del log de una transaccion.
//
// El log lo escriben varios procesos que se despliegan por separado, y un dato con una
// forma que el panel no espera tiraba la aplicacion entera: React desmonta todo el arbol
// cuando un componente falla al pintar, y el usuario se quedaba con la pagina en blanco.
// Aqui el fallo se queda dentro del bloque del log y el resto de la pantalla sigue viva.
//
// `resetKey` es el dato que se esta mostrando: si cambia (otra transaccion), se vuelve a
// intentar pintar en lugar de seguir ensenando el aviso de la anterior.
class LogErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey)
      this.setState({ error: null })
  }

  render() {
    if (!this.state.error)
      return this.props.children

    return (
      <Box sx={{ textAlign: 'left', marginTop: 1 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 'bold', color: 'error.main' }}>
          No se pudo mostrar el log
        </Typography>
        <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>
          El log trae un dato con una forma que el panel no reconoce. La transacción no se ve afectada.
        </Typography>
        <Typography sx={{ fontSize: 10, color: 'text.secondary', wordBreak: 'break-all', marginTop: 0.5 }}>
          {String(this.state.error?.message || this.state.error)}
        </Typography>
      </Box>
    )
  }
}

export default LogErrorBoundary
